<template>
  <v-dialog v-model="dialog" min-width="600" persistent>
    <v-card class="ins-card">
      <v-toolbar flat class="ins-hero">
        <div>
          <div class="text-h6 white--text">Programas cursados</div>
          <div class="text-body-2 white--text">
            Aqui ves donde esta inscrito este estudiante
          </div>
        </div>
        <v-spacer></v-spacer> 
      </v-toolbar>

      <v-card-text class="pt-4">
        <v-row dense>
          <v-col cols="12">
            <v-card outlined class="pa-3">
              <div class="text-subtitle-2 mb-2">Programas inscritos</div>

              <v-skeleton-loader
                v-if="loading"
                type="table"
                max-width="100%"
                class="mt-2"
              />

              <template v-else>
                <v-simple-table v-if="programas.length">
                  <thead>
                    <tr>
                      <th class="text-left">Código</th>
                      <th class="text-left">Programa</th>
                      <th class="text-left">Sede</th>
                      <th class="text-left">Versión</th>
                      <th class="text-left">Grupo</th>
                      <th class="text-left">Modalidad</th>
                      <th class="text-left">Gestión</th>
                      <th class="text-left">Registro</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(p, ind) in programas" :key="ind">
                      <td>{{ p.codigo }}</td>
                      <td style="max-width: 280px">{{ p.nombre_compuesto }}</td>
                      <td>{{ p.sede?.nombre }}</td>
                      <td>{{ p.version }}</td>
                      <td>{{ p.grupo }}</td>
                      <td>
                        <v-chip x-small color="deep-orange lighten-4" class="deep-orange--text text--darken-3" label>
                          {{ p.modalidad }}
                        </v-chip>
                      </td>
                      <td>{{ p.gestion }}</td>
                      <td>{{ formatFecha(p.fecha_registro) }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>

                <div v-else class="text-body-2 text--secondary">No hay programas registrados.</div>
              </template>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="cerrar()">Cerrar</v-btn> 
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<style scoped>
  .ins-card {
    border-radius: 16px;
    overflow: hidden;
  }
  .ins-hero {
    min-height: 90px;
    background: linear-gradient(120deg, #ff6a00 0%, #ff3d00 45%, #ffb300 100%);
  }
</style>

<script>
import gql from 'graphql-tag';

 

  export default {
    components: {},
    data() {
      return {
        dialog: false,
        loading: false,
        programas: [],
      };
    },
    methods: {
      async openmodal(row) { 
        window.console.log('rowww', row);
        this.programas = [];
        this.dialog = true;
        this.listar(row.id)
      },
      cerrar() {
        this.dialog = false;
      }, 
      async listar(idestudiante){
        this.loading = true;
        const sql = gql`
            query{
                getProgramasByPersona(student_id:${idestudiante}){
                id
                nombre_compuesto 
                sede{nombre}
                codigo,
                version,grupo,gestion,modalidad,fecha_registro
                }
            }
            `;
        const res = await this.$apollo
          .query({ query: sql })
          .then(({data}) => data)
          .catch(e=>e);
        this.loading = false;
        window.console.log('::::', res)
        if(res && res.getProgramasByPersona){
            this.programas = res.getProgramasByPersona;
        }
      },
      formatFecha(fecha){
        if(!fecha) return '';
        return new Date(fecha).toLocaleDateString();
      }
    },
  };
</script>
